<template>
  <Layout>
    <div :class="$style.advancedPlan">
      <div class="container">
        <div class="dingbeauty-banner-content ">
          <p class="sub-title">Intermediate Plan</p>
          <h1 class="title">進階方案</h1>
          <div class="description">
            <p>多店經營的巔峰之選！</p>
            <p>專為多分店經營者打造，無縫實現多店管理，</p>
            <p>既能夠滿足您的功能需求</p>
            <p>統一預約、資源分配，有效提升業績效益。</p>
            <p>讓預約管理更高效，掌握運營每一刻！</p>
          </div>
        </div>
      </div>
    </div>
    <SectionFeatures></SectionFeatures>
    <DingBeautyFunctions :functionList="functionList"></DingBeautyFunctions>
    <DingBeautyHelp></DingBeautyHelp>
  </Layout>
</template>

<script>
import Layout from '@layout/main'
import SectionFeatures from './components/SectionFeatures'
import DingBeautyFunctions from '@components/DingBeauty/DingBeautyFunctions.vue'
import DingBeautyHelp from '@components/DingBeauty/DingBeautyHelp.vue'

export default {
  page() {
    return {
      title: '方案價格',
    }
  },
  components: {
    Layout,
    SectionFeatures,
    DingBeautyFunctions,
    DingBeautyHelp,
  },

  data() {
    return {
      functionList: [
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_i01.svg'),
          title: '課程/療程方案',
          subTitle: '自由組合適用項目，快速設定各式方案，滿足客戶的多樣化需求，提升您的業務競爭力',
        },
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_02.svg'),
          title: '服務人員管理',
          subTitle: '明確設定每位服務人員的服務範疇，提供精準服務',
        },
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_03.svg'),
          title: '行銷管理整合',
          subTitle: '多元化的行銷方式，包括：優惠券、儲值金、數據分析等，讓您輕鬆制訂行銷策略',
        },
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_i04.svg'),
          title: '排班管理',
          subTitle: '獨家支援24小時全日排班，滿足各種排班需求，讓您輕鬆設定，管理事半功倍',
        },
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_05.svg'),
          title: '空間管理',
          subTitle: '自由管理各分店空間與人員的分配，最大化您的店面使用效率',
        },
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_i06.svg'),
          title: '管理帳號權限分級',
          subTitle: '擁有多種專業清楚的分工與管理權限，讓您透過簡單的操作，有效分配職位權責',
        },
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_07.svg'),
          title: '簡訊通知',
          subTitle: '自動發送預約通知，簡訊、Line、Email通通搞定，為您省去繁複的聯繫提醒，有效降低客戶缺席狀況',
        },
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_08.svg'),
          title: 'Line官方帳號預約',
          subTitle: '客戶可以輕鬆透過Line預約服務，也能輕鬆查詢包月和儲值狀態，提高預約便捷性',
        },
      ],
    }
  },
}
</script>

<style lang="scss" module>
.advancedPlan {
  position: relative;
  background: url('@assets/images/home/banner042.jpg');
  height: 100vh;
  background-size: cover;
  background-position: 78% center;

  // Darken background
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    background-color: rgba($color: #000000, $alpha: 0.2);
    width: 100%;
    height: 100%;
  }
}

@media (min-width: 992px) {
  .advancedPlan {
    height: 700px;
    background-position: center;
  }
}
</style>
